import { gameStateActions } from '../../../store/slices/game/slice';
import { toastActions } from '../../../store/slices/toast/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface TableCloseNotifyMessage extends GameCommunicationMessageType {
  duration: string;
  value?: string;
  tableId: string;
}

export class CoreTableCloseNotifyGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.TableCloseNotify;

  public process(message: TableCloseNotifyMessage): void {
    this.store.dispatch(
      gameStateActions.setTableCloseNotify({
        tableId: message?.tableId,
        duration: message?.duration,
      })
    );
    this.store.dispatch(toastActions.createToast('TABLE_WILL_CLOSE'));
  }
}
